export default "__VITE_ASSET__10aa2e95__"